import React from 'react';

import './PageNotFound.css';

const PageNotFound = (props) => {
  const currentPath = props.location.pathname;

  return (
    <div className="PageNotFound">
      <div className="text-center">
        <h1 className="display-4 mt-5 mb-3"> 404 - Page Not Found </h1>
        <p>
          <span className="font-weight-bold">
            Oh No!! Something went wrong!
          </span> <br />

          We can&#39;t find <a href="/reservations">http://members.rypeapp.com{ currentPath }</a> in
          our system. <br />

          Please check the URL and try again.
        </p>

      </div>
    </div>
  );
};


export default PageNotFound;



// WEBPACK FOOTER //
// ./src/components/PageNotFound/PageNotFound.js